import { Capacitor, registerPlugin } from '@capacitor/core';

const isAndroidNative =
  Capacitor.isNativePlatform() &&
  Capacitor.getPlatform() === 'android';

const ProximityScreen = isAndroidNative
  ? registerPlugin('ProximityScreen')
  : null;

export async function syncProximityScreen(callActive, proximityEnabled) {
  if (!ProximityScreen) {
    return {
      callActive: false,
      proximityEnabled: false,
      sensorAvailable: false,
    };
  }

  try {
    return await ProximityScreen.update({
      callActive: !!callActive,
      proximityEnabled: !!proximityEnabled,
    });
  } catch (err) {
    console.warn('[ProximityScreen] update failed', err);
    return {
      callActive: false,
      proximityEnabled: false,
      sensorAvailable: false,
    };
  }
}

export async function resetProximityScreen() {
  if (!ProximityScreen) return;

  try {
    await ProximityScreen.reset();
  } catch (err) {
    console.warn('[ProximityScreen] reset failed', err);
  }
}
